export const DISPLAY_STYLE = {
  LIST: 'list',
  GRID: 'grid'
};
